﻿import { createApi } from '@reduxjs/toolkit/query/react'
import { hcPortalBaseQuery } from '@/features/baseQuery.ts'
import { AddDepartmentRequest, Department, EditDepartmentRequest } from '@/features/employee-data/department.def.ts'

export const enumApi = createApi({
  reducerPath: 'enumApi',
  tagTypes: ['Department'],
  baseQuery: hcPortalBaseQuery(),
  endpoints: (builder) => ({
    getDepartments: builder.query<Department[], void>({
      query: () => ({
        url: '/Enum/GetDepartments',
        method: 'GET',
      }),
      providesTags: ['Department'],
    }),
    getDepartment: builder.query<Department, { id: number }>({
      query: ({ id }) => ({
        url: '/Enum/GetDepartment',
        method: 'GET',
        params: { id },
      }),
      providesTags: (_result, _error, { id }) => [{ type: 'Department', id }],
    }),
    addDepartment: builder.mutation<boolean, AddDepartmentRequest>({
      query: (body) => ({
        url: '/Enum/AddDepartment',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Department'],
    }),
    editDepartment: builder.mutation<boolean, EditDepartmentRequest>({
      query: (body) => ({
        url: '/Enum/EditDepartment',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Department'],
    }),
  }),
})

export const {
  useGetDepartmentsQuery,
  useGetDepartmentQuery,
  useAddDepartmentMutation,
  useEditDepartmentMutation,
} = enumApi
